module.exports = __webpack_public_path__ + "static/media/ancv.2ac12ef7.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Cart/ancv.png
// module id = 558
// module chunks = 0